import {createContext} from "react";
const DesignModeContext = createContext(false)

export default DesignModeContext;
